
import { EMPTY_QUOTATION_ENTITY, QuotationEntity } from "domain/entity/QuotationSetting/QuotationEntity";
import { BaseViewChangeSate } from "../BaseViewChangeState";


export interface QuotationModel {
    isLoading: boolean,
    quotationList: QuotationEntity[],
    isShowEditPanel: boolean,
    isEdit: boolean,
    isAdd: boolean,
    selectedRows: QuotationEntity[],
    currentRow: QuotationEntity,
    currentEditRow: QuotationEntity,
    masterState: QuotationViewChangeState,
}
export interface QuotationViewChangeState extends BaseViewChangeSate {
}

export const EMPTY_QUOTATION_MODEL: QuotationModel = {
    isLoading: false,
    quotationList: [],
    isShowEditPanel: false,
    isEdit: false,
    isAdd: false,
    selectedRows: [],
    currentRow: { ...EMPTY_QUOTATION_ENTITY },
    currentEditRow: { ...EMPTY_QUOTATION_ENTITY },
    masterState: {
        isSliderOpen: false,
        isTabularDataActive: false,
        isAdd: false,
        isRead: false,
        isEditable: false,
        isSaveClicked: false,
        lastEditRowId: "",
        isSelected: false,
        slider: {
            isAdd: false,
            isRead: false,
            isEditable: false
        }
    }
}